<!-- mettal-3\src\components\X272.vue -->
<template>
	<div :class="[`x2-6`, className || ``]" @click="$emit('click')">
		<!-- Внутренний элемент для отображения border -->
		<div class="card-border-x2"></div>
		<img
			class="image-15"
			src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------21@2x.png"
			alt="image"
		/>
		<div class="view-193">
			<p class="x01-19 poppins-semi-bold-white-16px" lang="ru">{{ x01 }}</p>
			<img
				class="vector-190"
				src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-614.svg"
				alt="Vector"
			/>
			<view692 />
		</div>
	</div>
</template>

<script>
import View692 from './View692'
export default {
	name: 'X272',
	components: {
		View692,
	},
	emits: ['click'],
	props: ['x01', 'className', 'durationText'],
}
</script>

<style>
.x2-6 {
	background-color: var(--storm-dust);
	border-radius: 12px;
	height: 90px;
	margin-left: 4px;
	margin-top: 12px;
	position: relative;
	width: 300px;
}

.image-15 {
	height: 86px;
	left: 4px;
	position: absolute;
	top: 3px;
	width: 293px;
}

.view-193 {
	height: 75px;
	left: 25px;
	position: absolute;
	top: 7px;
	width: 272px;
}

.text-25-1 {
	left: 0;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 57px;
}

.x01-19 {
	left: 38px;
	letter-spacing: 0;
	line-height: normal;
	position: absolute;
	top: 3px;
	width: 203px;
}

.vector-190 {
	height: 22.22%;
	left: 0;
	position: absolute;
	top: 12%;
	width: 9.19%;
}

.x2-6.x3-16,
.x2-6.x2-7 {
	margin-left: 5px;
}

/* Внутренний элемент для отображения border (радио-кнопка) */
/* .card-border-x2 {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	border: 3px solid transparent;
	border-radius: 12px;
	pointer-events: none;
	transition: border-color 0.3s ease, border-width 0.3s ease;
	z-index: 10;
} */

/* Неактивное состояние - прозрачная рамка */
.x2-6.lesson-card-inactive .card-border-x2 {
	border-color: transparent;
	border-width: 8px;
}

/* Активное состояние - темно-серая рамка */
.x2-6.lesson-card-active .card-border-x2 {
	border-color: transparent !important;
	border-width: 8px !important;
  margin-left: -3px;
}

.x2-6.lesson-card-selected .card-border-x2 {
	border-color: #4b4b4b !important;
	border-width: 8px !important;
}

/* Hover для неактивной карточки - полупрозрачная рамка */
.x2-6:not(.lesson-card-active):hover .card-border-x2 {
	border-color: transparent !important;
	border-width: 8px !important;
}
</style>
